import { useEffect, useLayoutEffect } from "react";
import { Route, Switch, Router, useLocation } from "wouter";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { Analytics } from "@/components/Analytics";
import Home from "@/pages/home";
import HowItWorks from "@/pages/how-it-works";
import Pricing from "@/pages/pricing";
import Security from "@/pages/security";
import About from "@/pages/about";
import Contact from "@/pages/contact";
import IndustriesIndex from "@/pages/industries/index";
import IndustryRoute from "@/pages/industries/[slug]";
import Terms from "@/pages/legal/terms";
import Privacy from "@/pages/legal/privacy";
import Dpa from "@/pages/legal/dpa";
import ConnectIdTerms from "@/pages/legal/connectid-terms";
import BrandPortal from "@/pages/brand";
import TrustIQ from "@/pages/trustiq";
import NotFound from "@/pages/not-found";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

// Disable the browser's built-in scroll restoration so it doesn't override
// our manual reset after client-side navigations.
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

function ScrollToTop() {
  const [location] = useLocation();
  // useLayoutEffect fires before paint — the browser never sees the old
  // scroll position on the new page.
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

export default function App() {
  return (
    <Router base={basePath}>
      <ScrollToTop />
      <Analytics />
      {/* /trustiq is exempt from the site gate so visitors from the lock screen
          can take the assessment and register interest before launch */}
      <Switch>
        <Route path="/trustiq">
          <Layout>
            <TrustIQ />
          </Layout>
        </Route>
        <Route>
          <Layout>
            <Switch>
              <Route path="/" component={Home} />
              <Route path="/how-it-works" component={HowItWorks} />
              <Route path="/pricing" component={Pricing} />
              <Route path="/security" component={Security} />
              <Route path="/about" component={About} />
              <Route path="/contact" component={Contact} />
              <Route path="/industries" component={IndustriesIndex} />
              <Route path="/industries/:slug" component={IndustryRoute} />
              <Route path="/legal/terms" component={Terms} />
              <Route path="/legal/privacy" component={Privacy} />
              <Route path="/legal/dpa" component={Dpa} />
              <Route path="/legal/connectid-terms" component={ConnectIdTerms} />
              <Route path="/brand" component={BrandPortal} />
              <Route path="/sign-up">
                {() => { window.location.replace("https://hub.fortifyid.com.au/app/sign-up"); return null; }}
              </Route>
              <Route component={NotFound} />
            </Switch>
          </Layout>
        </Route>
      </Switch>
      <Toaster position="top-center" richColors />
    </Router>
  );
}
